import * as React from 'react'

import { Input as AntInput, InputProps as AntInputProps } from 'antd'
import { useField, useFormikContext } from 'formik'

import FormGroup from '../FormGroup'
import DefaultFieldProps from '../FormGroup/DefaultFieldProps'

type FormikFieldProps = DefaultFieldProps &
  AntInputProps & {
    autoComplete?: any
    allowClear?: boolean
    affix?: React.ReactNode
  }

const FormikInputV2: React.FC<FormikFieldProps> = (props) => {
  const [field] = useField(props.name)
  const context = useFormikContext()

  return (
    <FormGroup {...props}>
      <AntInput
        {...props}
        value={field.value}
        onChange={(event: any) => {
          context.setFieldValue(props.name, event.target.value)
          props.onChange && props.onChange(event.target.value)
        }}
      />
    </FormGroup>
  )
}

export const { Search } = AntInput

export default FormikInputV2
